<template>
  <div>
    <p class="tw-text-2xl tw-mx-2 tw-mt-4 tw-font-semibold">Admin Dashboard</p>
    <Landing class="tw-mx-2 tw-mb-4 tw-text-white" />
    <div class="tw-flex tw-flex-wrap">
      <div class="tw-w-full md:tw-w-1/3 ">
        <v-card class="tw-p-2 tw-m-2 tw-bg-eko-blue" >
          <p class="tw-text-center tw-text-eko-blue">Lister Projects Submitted</p>
          <line-chart :height="300" />
        </v-card>
      </div>

      <div class="tw-w-full md:tw-w-1/3 ">
        <v-card class="tw-p-2 tw-m-2 tw-bg-eko-blue" >
          <p class="tw-text-center tw-text-eko-blue">Lister Projects Submitted</p>
          <line-chart :height="300" />
        </v-card>
      </div>

      <div class="tw-w-full md:tw-w-1/3 ">
        <v-card class="tw-p-2 tw-m-2 tw-bg-eko-blue" >
          <p class="tw-text-center tw-text-eko-blue">Lister Projects Submitted</p>
          <line-chart :height="300" />
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";
import LineChart from "@/components/Shared/Charts/LineChart.vue";
import Landing from "@/components/Admin/Landing.vue";

export default {
  extends: Bar,
  components: {
    LineChart,
    Landing
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped></style>
